import { absolutePath } from "./absolutePath";

interface CommunityAiAgentProfileFnProps {
  agentId: number;
  params?: Record<string, unknown>;
}

export const communityAiAgentProfile = {
  show: ({ agentId, params = {} }: CommunityAiAgentProfileFnProps) =>
    absolutePath(`community_ai_agent_profiles/${agentId}`, params),
};
